import { combineReducers } from '@reduxjs/toolkit';
import user from '../features/userSlice';
import window from '../features/windowSlice';

const rootReducer = combineReducers({
    user,
    window
});

export default rootReducer;